import { createReducer } from '@reduxjs/toolkit'
import { types } from 'actions/elements_groups_enabled_columns'

const initialState = {
  selectedColumns: []
}

function insertIntoPosition(array, item, position) {
  // Remove item if it already exists
  const existingIndex = array.indexOf(item)
  if (existingIndex !== -1) {
    array.splice(existingIndex, 1)
  }
  
  // Insert at position (or end if undefined)
  const insertPos = position !== undefined ? position : array.length
  array.splice(insertPos, 0, item)
}

export default createReducer(initialState, (builder) => {
  builder
    .addCase(types.LOAD_SELECTED, (state, action) => {
      state.selectedColumns = action.names || []
    })
    .addCase(types.DROP_TO_SELECTED, (state, action) => {
      insertIntoPosition(state.selectedColumns, action.name, action.position)
    })
    .addCase(types.DROP_TO_AVAILABLE, (state, action) => {
      state.selectedColumns = state.selectedColumns.filter(item => item !== action.name)
    })
})
